export default "__VITE_ASSET__dde7801a__"